import { Pill, Tablets, FlaskConical, Package, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "../../lib/services";

const ICONS = {
  capsules: Pill,
  tablets: Tablets,
  powders: FlaskConical,
  packaging: Package,
};

export const Services = ({ onQuoteClick }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="overline">
            <span className="gold-divider mr-3 align-middle" />
            What we manufacture
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1A1A1A] mt-6 leading-tight">
            Capsules. Tablets.
            <br />
            Powders. Packaging.
          </h2>
          <p className="text-[#595959] mt-5 leading-relaxed">
            Four manufacturing capabilities under one certified roof. Tap any
            capability to explore what we produce — exact specs are
            finalised when you request a quote.
          </p>
        </div>

        {/* Bento grid */}
        <div className="mt-14 grid md:grid-cols-12 gap-4 md:gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.slug];
            const spans =
              i === 0
                ? "md:col-span-7"
                : i === 1
                  ? "md:col-span-5"
                  : i === 2
                    ? "md:col-span-5"
                    : "md:col-span-7";
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className={`group relative flex flex-col text-left bg-white border border-[#E5E5E5] p-7 md:p-8 ${spans} md:min-h-[240px] transition-all hover:border-[#D4AF37] hover:shadow-[0_14px_40px_-18px_rgba(212,175,55,0.35)]`}
              >
                <div className="flex items-start justify-between">
                  <Icon
                    className="w-7 h-7 text-[#D4AF37]"
                    strokeWidth={1.4}
                  />
                  <ArrowUpRight className="w-5 h-5 text-[#1A1A1A]/40 group-hover:text-[#D4AF37] transition-colors" />
                </div>
                <div className="mt-6 font-serif-display text-2xl md:text-3xl text-[#1A1A1A]">
                  {s.title}
                </div>
                <p className="mt-3 text-sm md:text-base text-[#595959] leading-relaxed max-w-md">
                  {s.short}
                </p>
                <div className="mt-auto pt-6 text-xs tracking-[0.2em] uppercase text-[#1A1A1A] group-hover:text-[#C5A059] transition-colors">
                  View capability →
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-7 md:p-8 border border-[#E5E5E5] bg-white">
          <div>
            <div className="font-serif-display text-xl md:text-2xl text-[#1A1A1A]">
              Need a private-label or bulk quotation?
            </div>
            <div className="text-sm text-[#595959] mt-1">
              Share your product spec — we reply within one business day.
            </div>
          </div>
          <button
            data-testid="services-quote-cta"
            onClick={onQuoteClick}
            className="btn-gold rounded-sm h-11 px-6 text-sm font-semibold tracking-wider inline-flex items-center gap-2"
          >
            Request Quote <ArrowUpRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
